import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLanguage } from "@/context/LanguageContext";
import { Megaphone, X } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AnnouncementBar() {
  const { language, t } = useLanguage();
  const [ann, setAnn] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/announcement`)
      .then((r) => {
        if (mounted) setAnn(r.data || null);
      })
      .catch(() => mounted && setAnn(null));
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const visible = ann && !dismissed && (ann.message_en || ann.message_es);
    const root = document.documentElement;
    if (visible) root.classList.add("has-announcement");
    else root.classList.remove("has-announcement");
    return () => root.classList.remove("has-announcement");
  }, [ann, dismissed]);

  if (!ann || dismissed) return null;
  const msg = (language === "es" ? ann.message_es : ann.message_en) || ann.message_en || ann.message_es;
  if (!msg) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 inset-x-0 z-[55] bg-[#232321] text-[#F9F6F0] border-b border-[#C05A3A]/60"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-2.5 flex items-center gap-3 text-sm">
        <Megaphone className="h-4 w-4 text-[#E6A85C] shrink-0" strokeWidth={1.5} />
        <p className="flex-1 truncate sm:whitespace-normal leading-snug">{msg}</p>
        <button
          onClick={() => setDismissed(true)}
          aria-label={t("announcement.dismiss")}
          data-testid="announcement-dismiss"
          className="h-7 w-7 rounded-full hover:bg-[#F9F6F0]/10 flex items-center justify-center shrink-0"
        >
          <X className="h-4 w-4" strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}
